import { defineMessages } from 'react-intl';

export default defineMessages({
    hoPolicyChange: {
        id: 'endorsement.cl.directives.templates.cl-type-changes.Type Changes',
        defaultMessage: 'Type Changes'
    }
});
